/* Common Imports */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import AmenitiesMobileCard from "./sub-components/AmenitiesMobileCard";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    width: "100%",
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "0.5rem",
  },
  heading: {
    width: "100%",
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    color: "#A8626C",
    fontWeight: "500",
    fontSize: "1rem",
    lineHeight: "1.5rem",
  },
  mainContainer: {
    padding: "0rem 8rem 0rem 8rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("lg")]: {
      padding: "0rem 1rem 0rem 1rem",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "0.75rem",
    flexWrap: "wrap",
  },
  amenityCard: {
    width: "48%",
    padding: "0.5rem",
    borderRadius: "1rem",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.only("md")]: {
      width: "48%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
    },
    // fill: "#A8626C33",
    "& img": {
      width: "56px",
      height: "56px",
      fill: "#A8626C33",
    },
    "& svg": {
      width: "56px",
      height: "56px",
      fill: "#A8626C33",
    },
  },
  showMoreText: {
    color: "#A8626C",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    textDecoration: "none",
    marginTop: "1rem",
  },
}));

const AmenitiesMobile = () => {
  const classes = useStyles();
  const [showAll, setShowAll] = React.useState(false);

   const amenities = [
     { title: "Business center", icon: "/images/halcyon-logo/amenities/business_centre_icon.png" },
     { title: "Multi purpose hall", icon: "/images/halcyon-logo/amenities/hall_icon.png" },
     { title: "Indoor games", icon: "/images/halcyon-logo/amenities/indoor_games_icon.png" },
     { title: "Gym", icon: "/images/halcyon-logo/amenities/gym_icon.png" },
     { title: "Yoga", icon: "/images/halcyon-logo/amenities/yoga_icon.png" },
     { title: "Pool", icon: "/images/halcyon-logo/amenities/pool_icon.png" },
     { title: "Kids play area", icon: "/images/halcyon-logo/amenities/kids_play_area_icon.png" },
     { title: "Herb garden", icon: "/images/halcyon-logo/amenities/herbs_icon.png" },
     { title: "Senior citizen park", icon: "/images/halcyon-logo/amenities/senior_park_icon.png" },
     { title: "Akhada", icon: "/images/halcyon-logo/amenities/akhada_icon.png" },
     { title: "Barbeque", icon: "/images/halcyon-logo/amenities/barbecue_area_icon.png" },
     { title: "Pets play area", icon: "/images/halcyon-logo/amenities/pet_park_icon.png" },
     { title: "Pickle ball court", icon: "/images/halcyon-logo/amenities/pickle_ball.png" },
     { title: "Spike ball court", icon: "/images/halcyon-logo/amenities/spike_ball_icon.png" },
     { title: "Basket ball court", icon: "/images/halcyon-logo/amenities/basketball_icon.png" },
   ];

  const visibleAmenities = showAll ? amenities : amenities.slice(0, 4);

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h6"
            component="h6"
            className={classes.heading}
          >
            Amenities
          </Typography>
          <div className={classes.cardContainer}>
            {visibleAmenities.map((amenity, index) => (
              <AmenitiesMobileCard
                key={index}
                title={amenity.title}
                icon={amenity.icon}
                className={classes.amenityCard}
              />
            ))}
          </div>
          <Typography
            variant="body1"
            component="span"
            className={classes.showMoreText}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show less amenities" : "+9 More amenities"}
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AmenitiesMobile;
